import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class FlightReportPowerCheckTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          flight_report_power_checks: this.props.flight_report_power_checks,
          flight_report_id: this.props.flight_report_id,
          engine: '',
          altitude: '',
          external_temperature: '',
          power_turbine_rotation_rate: '',
          engine_power_rate: '',
          gas_turbine_rotation_rate: '',
          engine_temperature: '',
          engine_temperature_margin: '',
          gas_turbine_torque_margin: '',
          rawInputValue: '',
          rawInputValueTorque: '',
          flight_legs_list: [],
        };
        this.add = this.add.bind(this);
        this.delete = this.delete.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }

      handleChangeDecimal = (name, event) => {
        let rawInputValue = this.state.rawInputValue;
      
        let inputValue = event.target.value;
      
        // Se o input estiver vazio, limpa rawInputValue
        if (inputValue === '') {
          rawInputValue = '';
        } else if (/^\d+$/.test(inputValue)) {
          // Se for um número inteiro, atualiza rawInputValue
          rawInputValue = inputValue;
        } else {
          let newChar = inputValue.slice(-1);
      
          // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
          if (!/^[0-9.,]$/.test(newChar)) {
            // Caractere inválido, não faz nada
            return;
          }
      
          // Substitui vírgula por ponto
          if (newChar === ',') {
            newChar = '.';
          }
      
          // Verifica se já existe um ponto decimal
          let hasDecimal = rawInputValue.includes('.');
      
          // Impede que "0" seja o primeiro dígito
          if (rawInputValue === '' && newChar === '0') {
            return;
          }
      
          // Determina se está adicionando ou removendo um caractere
          if (event.nativeEvent.inputType === 'deleteContentBackward') {
            // Removendo um caractere
            rawInputValue = rawInputValue.slice(0, -1);
          } else if (hasDecimal && newChar !== '.') {
            // Substitui o dígito após o ponto decimal
            let parts = rawInputValue.split('.');
            parts[1] = newChar;
            rawInputValue = parts.join('.');
          } else {
            // Adicionando um caractere
            rawInputValue += newChar;
          }
        }
            
        // Formata o valor para exibição com base em rawInputValue
        let formattedValue = this.formatInputValue(rawInputValue);
      
        // Atualiza o estado
        this.setState({
          [name]: formattedValue,
          rawInputValue: rawInputValue
        });
      };

      handleChangeTorqueDecimal = (name, event) => {
        let rawInputValue = this.state.rawInputValueTorque;
      
        let inputValue = event.target.value;
      
        // Se o input estiver vazio, limpa rawInputValue
        if (inputValue === '') {
          rawInputValue = '';
        } else if (/^\d+$/.test(inputValue)) {
          // Se for um número inteiro, atualiza rawInputValue
          rawInputValue = inputValue;
        } else {
          let newChar = inputValue.slice(-1);
      
          // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
          if (!/^[0-9.,]$/.test(newChar)) {
            // Caractere inválido, não faz nada
            return;
          }
      
          // Substitui vírgula por ponto
          if (newChar === ',') {
            newChar = '.';
          }
      
          // Verifica se já existe um ponto decimal
          let hasDecimal = rawInputValue.includes('.');
      
          // Impede que "0" seja o primeiro dígito
          if (rawInputValue === '' && newChar === '0') {
            return;
          }
      
          // Determina se está adicionando ou removendo um caractere
          if (event.nativeEvent.inputType === 'deleteContentBackward') {
            // Removendo um caractere
            rawInputValue = rawInputValue.slice(0, -1);
          } else if (hasDecimal && newChar !== '.') {
            // Substitui o dígito após o ponto decimal
            let parts = rawInputValue.split('.');
            parts[1] = newChar;
            rawInputValue = parts.join('.');
          } else {
            // Adicionando um caractere
            rawInputValue += newChar;
          }
        }
            
        // Formata o valor para exibição com base em rawInputValue
        let formattedValue = this.formatInputValue(rawInputValue);
      
        // Atualiza o estado
        this.setState({
          [name]: formattedValue,
          rawInputValueTorque: rawInputValue
        });
      };
                                    
      formatInputValue = (rawValue) => {
        if (!rawValue) {
          return '';
        }

        let [inteiro, decimal] = rawValue.split('.');

        // Ajusta a parte decimal para sempre ter um dígito
        decimal = decimal && decimal.length > 0 ? decimal[0] : '0';

        return `${inteiro}.${decimal}`;
      };

    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            flight_report_id: newProps.flight_report_id,
            loaded: 1,
          });
        }

        if(typeof newProps.flight_report_power_checks !== 'undefined' && newProps.flight_report_power_checks !== null && this.state.loaded === 1) {
          this.setState({
            flight_report_power_checks: newProps.flight_report_power_checks,
          });
        }
      }
    
      // Fetch salvando a edição
      add(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var datasave = {
          flight_report_id: this.state.flight_report_id,
          engine: this.state.engine,
          altitude: this.state.altitude,
          external_temperature: this.state.external_temperature,
          power_turbine_rotation_rate: this.state.power_turbine_rotation_rate,
          engine_power_rate: this.state.engine_power_rate,
          gas_turbine_rotation_rate: this.state.gas_turbine_rotation_rate,
          engine_temperature: this.state.engine_temperature,
          engine_temperature_margin: this.state.engine_temperature_margin,
          gas_turbine_torque_margin: this.state.gas_turbine_torque_margin,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/power/checks', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
            self.setState({
              altitude: '',
              engine: '',
              external_temperature: '',
              power_turbine_rotation_rate: '',
              engine_power_rate: '',
              gas_turbine_rotation_rate: '',
              engine_temperature: '',
              engine_temperature_margin: '',
              gas_turbine_torque_margin: '',
            });
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      delete (id) {
        if (window.confirm('Deseja realmente excluir este registro?')) {
          this.props.handleAlert('', '', 'open');
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function(value) {
            fetch(config.get('api') + '/relatorio/voo/power/check/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.refs.request_api.validate(responseJson, 'alert');
              if (responseJson.status === 'success') {
                self.props.updateData(responseJson);
              } else {
                self.props.handleAlert(responseJson.message, responseJson.status, 'open');
              }
            }).catch((error) => {
              console.error(error);
            });
          });
        }
      }
    
      render() {
        var self = this;
        return (
    <div>
      <RequestApi ref={'request_api'} />
        <h3 className="page-title pull-left">Power Check</h3>
        <div className="clearfix"></div>
        <hr/>
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>Engine</label>
                <br/>
                <Select
                  className="form-group"
                  name="engine"
                  value={this.state.engine}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'engine')}
                  options={[
                    {value: "ENG #1", label: "ENG #1"},
                    {value: "ENG #2", label: "ENG #2"},
                    {value: "APU", label: "APU"},
                  ]}
                  required
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Altitude</label>
                <input type="number" className="form-control" value={this.state.altitude} name="altitude" onChange={this.handleChange.bind(this, 'altitude')} placeholder="Altitude" required />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>OAT</label>
                <br/>
                <input type="number" className="form-control" value={this.state.external_temperature} name="external_temperature" onChange={this.handleChange.bind(this, 'external_temperature')} placeholder="Temperatura externa" required />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>N2/NR</label>
                <br/>
                <input type="number" className="form-control" value={this.state.power_turbine_rotation_rate} name="power_turbine_rotation_rate" onChange={this.handleChange.bind(this, 'power_turbine_rotation_rate')} placeholder="Taxa de rotação da turbina de potência" required />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Torque</label>
                <br/>
                <input type="number" className="form-control" value={this.state.engine_power_rate} name="engine_power_rate" onChange={this.handleChange.bind(this, 'engine_power_rate')} placeholder="Taxa de potência do motor" required />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>N1/NG</label>
                <input className="form-control" value={this.state.gas_turbine_rotation_rate} name="gas_turbine_rotation_rate" onChange={this.handleChangeDecimal.bind(this, 'gas_turbine_rotation_rate')} placeholder="Taxa de rotação da turbina de gases do motor" required />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>T4/T5/ITT/TOT/MGT (°C)</label>
                <br/>
                <input type="number" className="form-control" value={this.state.engine_temperature} name="engine_temperature" onChange={this.handleChange.bind(this, 'engine_temperature')} placeholder="Temperatura do motor" required />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Margin - T5/ITT/T4/TOT/MGT (°C)</label>
                <br/>
                <input type="number" className="form-control" value={this.state.engine_temperature_margin} name="engine_temperature_margin" onChange={this.handleChange.bind(this, 'engine_temperature_margin')} placeholder="Margem de temperatura do motor" required />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Margin - NG/Torque</label>
                <br/>
                <input className="form-control" value={this.state.gas_turbine_torque_margin} name="gas_turbine_torque_margin" onChange={this.handleChangeTorqueDecimal.bind(this, 'gas_turbine_torque_margin')} placeholder="Margem de torque da turbina de gases" required />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <button type="submit" className="btn btn-block btn-primary"><i className="fa fa-fw fa-save"></i> Cadastrar</button>
              </div>
            </div>
          </div>
        </form>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            {/* <caption>Power Checks</caption> */}
            <thead>
              <tr>
                <th rowSpan={2} className="text-center vcenter">Engine</th>
                <th rowSpan={2} className="text-center vcenter">Altitude</th>
                <th rowSpan={2} className="text-center vcenter">OAT</th>
                <th rowSpan={2} className="text-center vcenter">N2/NR</th>
                <th rowSpan={2} className="text-center vcenter">Torque</th>
                <th rowSpan={2} className="text-center vcenter">N1/NG</th>
                <th rowSpan={2} className="text-center vcenter">T4/T5/ITT/TOT/MGT (°C)</th>
                <th colSpan={2} className="text-center vcenter">Margins</th>
                <th rowSpan={2} className="text-center vcenter"></th>
              </tr>
              <tr>
                <th className="text-center vcenter">T5/ITT/T4/TOT/MGT (°C)</th>
                <th className="text-center vcenter">NG/Torque</th>
              </tr>
            </thead>
              <tbody id="power_checks">
                {Object.keys(self.state.flight_report_power_checks).map(function(k) {
                  var power_check = self.state.flight_report_power_checks[k];
                  return(
                    <tr className="text-center" key={power_check.id}>
                      <td>{power_check.engine}</td>
                      <td>{power_check.altitude}</td>
                      <td>{power_check.external_temperature}</td>
                      <td>{power_check.power_turbine_rotation_rate}</td>
                      <td>{power_check.engine_power_rate}</td>
                      <td>{power_check.gas_turbine_rotation_rate_decimal}</td>
                      <td>{power_check.engine_temperature}</td>
                      <td>{power_check.engine_temperature_margin}</td>
                      <td>{power_check.gas_turbine_torque_margin_decimal}</td>
                      <td style={{width: '100px', whiteSpace: 'nowrap', textAlign: 'center'}}>
                        <button onClick={() => self.delete(power_check.id)} className="btn btn-danger btn-sm button-inline"><i className="fa fa-trash"></i></button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
          </table>
        </div>
    </div>
    );
  }
}

export default FlightReportPowerCheckTab;




// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportPowerCheckTab.js